import { ComponentProps, MenuControls } from "api-sdk-react"
import { ChatNode } from "api-sdk"
import { ReaderConfig } from "reader-common"
import { ChatStyleConfig } from "../../types"
import React from "react"
import { ChatMessageHeader } from "./chatMessageHeader"

interface ChatNodeMessagesProps extends ComponentProps {
    node: ChatNode,
    config: ReaderConfig,
    styleConfig: ChatStyleConfig,
    menu: MenuControls,
    animateEntry?: boolean,
    animateLeave?: boolean,
}

export function ChatNodeMessages(props: ChatNodeMessagesProps) {
    return props.node.messages.map((msg, idx) => {
        const author = msg.type === "USER" ? "user" : "partner"
        const actualMessage = msg.type === "USER" && msg.actionLabel != null ? msg.actionLabel : msg.message

        const actionDesc = (msg.type !== "USER" && msg.action?.description != null && msg.action.description !== msg.message) ?
            <span className="post-action-desc"> { msg.action.description } </span>
            : null
        return (
            <div
                aria-atomic
                className={`message ${author}-message ${props.animateLeave ? "animated-leave" : ""}`}
                key={idx}>
                <ChatMessageHeader config={props.config} styleConfig={props.styleConfig} target={author}/>
                <div
                    className={`message-content ${(props.animateEntry && author === "partner") ? " animated-entry-partner" : ""}`}
                    role="document">
                    { actualMessage }
                </div>
                { actionDesc}
            </div>
        )
    })
}